export const inkColors = {
    'AMBER': { name: 'Amber', icon: '/icons/ink-amber.webp', color: '#fbbf24' },
    'AMETHYST': { name: 'Amethyst', icon: '/icons/ink-amethyst.webp', color: '#8b5cf6' },
    'EMERALD': { name: 'Emerald', icon: '/icons/ink-emerald.webp', color: '#10b981' },
    'RUBY': { name: 'Ruby', icon: '/icons/ink-ruby.webp', color: '#ef4444' },
    'SAPPHIRE': { name: 'Sapphire', icon: '/icons/ink-sapphire.webp', color: '#3b82f6' },
    'STEEL': { name: 'Steel', icon: '/icons/ink-steel.webp', color: '#6b7280' }
}; 